import axios from 'axios';
import notify from '@/store/Common/notify';
import commitFieldOptions from '@/store/Modules/Field/common/commitFieldOptions';

const actions = {
    getData({ commit, state }, value) {
        return new Promise((resolve, reject) => {
            commit('overlay/toggle', true, { root: true });
            commit('setFieldId', value);

            axios.get('/api/site/field/' + state.fieldId)

            // Success
                .then((response) => {
                    const field = response.data.data.field;
                    const userMedia = response.data.data.userMedia;
                    commit('setName', field.name);
                    commit('setType', field.type);
                    commit('setCard', field.card.name);
                    commit('setSection', field.card.section && field.card.section.name ? field.card.section.name : null);
                    commit('setStep', field.card.section && field.card.section.step.name ? field.card.section.step.name : '' );
                    commit('setPopulation', field.population[0] ? field.population[0].population : [] );
                    commit('setSubmission', field.submission[0] ? field.submission[0].submission : [] );
                    commit('setUserMedia', userMedia ? userMedia : []);
                    commit('setStockMedia', field.media ? field.media : null);

                    /**
                     * Options
                     */
                    if (field.options) {
                        commitFieldOptions(field, commit);
                    }

                    /**
                     * Visibility
                     */
                    commit('setHydrated', true);
                    commit('overlay/toggle', false, { root: true });
                    resolve();
                })

            // If there's an error here, the item doesn't exist.
                .catch((error) => {
                    notify(error.response.data.message, 'error');
                    reject();
                });
        });
    }
};

export default actions;
